import { render, staticRenderFns } from "./WireTransferForm.vue?vue&type=template&id=336d15a8"
import script from "./WireTransferForm.vue?vue&type=script&lang=js"
export * from "./WireTransferForm.vue?vue&type=script&lang=js"
import style0 from "./WireTransferForm.vue?vue&type=style&index=0&id=336d15a8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports